import { Avatar, Box, Skeleton, Typography } from '@mui/material';
import { getInitials } from 'utilities';
import { CommonCellProps } from './cells.props';


const ConsultantCell = ({ valuationRow }: CommonCellProps) => {
  if (valuationRow.is_loading_additional_data) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Skeleton variant="circular" width={28} height={28} />
        <Box>
          <Skeleton variant="text" width={120} height={20} />
        </Box>
      </Box>
    );
  }

  if (valuationRow.other_consultant && valuationRow.other_consultant !== '-') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Avatar
          alt={valuationRow.other_consultant}
          src={
            valuationRow.other_consultant_image_src && valuationRow.other_consultant_image_src !== '-'
              ? valuationRow.other_consultant_image_src
              : undefined
          }
          sx={{ width: 28, height: 28, fontSize: '0.75rem' }}>
          {getInitials({ name: valuationRow.other_consultant })}
        </Avatar>
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: 1.2 }}>
            {valuationRow.other_consultant}
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Typography variant="body2" color="text.secondary">
      -
    </Typography>
  );
};

export default ConsultantCell;

